var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4537 7.70711C16.8442 7.31658 16.8442 6.68342 16.4537 6.29289L10.4537 0.292893C10.0632 -0.0976317 9.43 -0.0976318 9.03948 0.292893C8.64895 0.683417 8.64895 1.31658 9.03948 1.70711L14.3324 7L9.03948 12.2929C8.64895 12.6834 8.64895 13.3166 9.03948 13.7071C9.43 14.0976 10.0632 14.0976 10.4537 13.7071L16.4537 7.70711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45369 7.70711C8.84421 7.31658 8.84421 6.68342 8.45369 6.29289L2.45369 0.292893C2.06317 -0.0976317 1.43 -0.0976318 1.03948 0.292893C0.648953 0.683417 0.648953 1.31658 1.03948 1.70711L6.33237 7L1.03948 12.2929C0.648952 12.6834 0.648952 13.3166 1.03948 13.7071C1.43 14.0976 2.06317 14.0976 2.45369 13.7071L8.45369 7.70711Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageEnd);
export default __webpack_public_path__ + "static/media/page_end.6e1e77c77e33fabb49ae55fef39b875c.svg";
export { ForwardRef as ReactComponent };